//Componentes generales
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

//Rutas
import Routes_gral from "../../utils/Routes_gral";

//Permisos
import {
  VER_USUARIOS,
  VER_PRODUCTOS,
  VER_GRUPOS,
  VER_SECTORES_REQUERIMIENTOS,
  VER_SUBCUENTAS,
  VER_DEPOSITOS,
  VER_DISTRIBUCIONES,
} from "../../utils/permisos";

//Estilos
import "./Navbar.css";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faUsersBetweenLines,
  faHouse,
  faBasketShopping,
  faPeopleGroup,
  faPlusSquare,
  faUsers,
  faLocation,
  faCoins,
  faWarehouse,
  faSitemap,
} from "@fortawesome/free-solid-svg-icons";

/*
  Componente encarado de las redirecciones de navegación de la pagina.
    Donde usuario es el usuario en sesión.
*/
const StyledNavbar_bottom = ({ usuario }) => {
  return (
    <div className="navbar-xx">
      <nav className="navbar-container-xx">
        <NavLink
          to={Routes_gral.home}
          //to={null}
          className="link navbar-item-xx"
        >
          <FontAwesomeIcon icon={faHouse} className="icon-navbar" />
          <div className="navbar-item-label-bottom-xx">Home</div>
        </NavLink>
        <NavLink
          to={Routes_gral.addReq}
          //to={null}
          className="link navbar-item-xx"
        >
          <FontAwesomeIcon icon={faPlusSquare} className="icon-navbar" />{" "}
          <div className="navbar-item-label-bottom-xx">Agregar</div>
        </NavLink>
          <NavLink to={Routes_gral.product} className="navbar-item-xx">
            <FontAwesomeIcon icon={faBasketShopping} className="icon-navbar" />
            <div className="navbar-item-label-bottom-xx" color="white">
              Productos
            </div>
          </NavLink>
        {usuario.userType.some((item) =>
          VER_SECTORES_REQUERIMIENTOS.includes(item.typeName)
        ) && (
          <NavLink
            to={Routes_gral.reqSector}
            className="link navbar-item-xx"
          >
            <FontAwesomeIcon icon={faLocation} className="icon-navbar" />{" "}
            <div className="navbar-item-label-bottom-xx">
              Sectores de Requerimientos
            </div>
          </NavLink>
        )}
        {usuario.userType.some((item) =>
          VER_DEPOSITOS.includes(item.typeName)
        ) && (
          <NavLink
            to={Routes_gral.warehouse}
            className="link navbar-item-xx"
          >
            <FontAwesomeIcon icon={faWarehouse} className="icon-navbar" />{" "}
            <div className="navbar-item-label-bottom-xx">
              Depósitos
            </div>
          </NavLink>
        )}
        {usuario.userType.some((item) =>
          VER_DISTRIBUCIONES.includes(item.typeName)
        ) && (
          <NavLink
            to={Routes_gral.distribucion}
            className="link navbar-item-xx"
          >
            <FontAwesomeIcon icon={faSitemap} className="icon-navbar" />{" "}
            <div className="navbar-item-label-bottom-xx">
              Distribuciones
            </div>
          </NavLink>
        )}
        {usuario.userType.some((item) =>
          VER_SUBCUENTAS.includes(item.typeName)
        ) && (
          <NavLink to={Routes_gral.subcuentas} className="navbar-item-xx">
            <FontAwesomeIcon icon={faCoins} className="icon-navbar" />
            <div className="navbar-item-label-bottom-xx" color="white">
              Subcuentas
            </div>
          </NavLink>
        )}
        {usuario.userType.some((item) =>
          VER_USUARIOS.includes(item.typeName)
        ) && (
          <NavLink to={Routes_gral.user} className="link navbar-item-xx">
            <FontAwesomeIcon icon={faUsers} className="icon-navbar" />{" "}
            <div className="navbar-item-label-bottom-xx">Usuarios</div>
          </NavLink>
        )}
        {usuario.userType.some((item) =>
          VER_GRUPOS.includes(item.typeName)
        ) && (
          <NavLink to={Routes_gral.group} className="link navbar-item-xx">
            <FontAwesomeIcon
              icon={faUsersBetweenLines}
              className="icon-navbar"
            />{" "}
            <div className="navbar-item-label-bottom-xx">Grupos</div>
          </NavLink>
        )}
      </nav>
    </div>
  );
};
export default StyledNavbar_bottom;